<template>
  <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
    <div class='machine-grid'>
      <dx-data-grid ref='refMachineGrid'
        :data-source='machineInfoList'
        :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
        :hover-state-enabled = "true" :allowColumnResizing = 'true'
        column-resizing-mode = 'widget' :allow-column-reordering = "true"
        :height='gridHeight' :row-alternation-enabled="true"
        :focused-row-enabled="true"
        @focused-row-changed="onSelectionChanged"
        :auto-navigate-to-focused-row="false"
        key-expr="설비코드"
        :focused-row-key.sync='focusedRowKey'
        @row-removed='onRowRemoved' @row-inserted='onRowInserted' @row-inserting='onRowInserting'
        @row-updated='onRowUpdated' @row-updating='onUpdating'
        @editor-preparing='onEditorPreparing'
        @init-new-row='onInitNewRow'
      >
        <DxSearchPanel
          :visible="true"
          placeholder="검색..."
        />
        <DxExport
          :enabled="true"
          file-name="설비정보"
        />
        <DxFilterRow
          :visible="true"
          apply-filter="auto"
        />
        <DxEditing
          :allow-deleting="(userInfo.permission & crudAllow) > 0"
          :allow-updating="(userInfo.permission & crudAllow) > 0"
          :allow-adding="(userInfo.permission & crudAllow) > 0"
          :use-icons="true"
          mode='popup'
        >
          <DxPopup
            :show-title="true"
            :width="700"
            :height="330"
            title="설비정보등록"
          >
            <dx-position
              my="center"
              at="center"
              of="window"
            />
          </DxPopup>
          <DxForm>
              <DxItem
              :col-count="2"
              :col-span="2"
              item-type="group"
              >
                <DxItem data-field="설비코드"/>
                <DxItem data-field="설비명"/>
                <DxItem data-field="설비유형"/>
                <DxItem data-field="규격"/>
                <DxItem data-field="제조사"/>
                <DxItem data-field="제조사일련번호"/>
                <DxItem data-field="제조사모델번호"/>
                <DxItem data-field="구입년도"/>
                <DxItem data-field="구입가격"/>
                <DxItem data-field="비고"/>
                <DxItem data-field="사용유무"/>
                <DxItem data-field="삭제유무"/>

              </DxItem>
            </DxForm>
        </DxEditing>
        <DxColumnFixing :enabled="true"/>
        <DxColumn
          width="90"
          :buttons="editButtons"
          type="buttons"
        />
        <DxColumn
          :allowEditing='isIdEdit'
          :fixed="true"
          caption="설비코드"
          data-field="설비코드"
          sort-order='asc'
        >
          <dx-required-rule message="항목을 입력하세요"/>
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="설비명"
          data-field="설비명"
          :visible='true'
          :fixed="true"
        >
          <dx-required-rule message="항목을 입력하세요"/>
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="설비유형"
          data-field="설비유형"
          :visible='true'
        >
          <DxLookup
            :data-source="machineTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
          <dx-required-rule message="항목을 선택하세요"/>
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="규격"
          data-field="규격"
          :visible='true'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="제조사"
          data-field="제조사"
          :visible='true'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="일련번호"
          data-field="제조사일련번호"
          :visible='true'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="모델번호"
          data-field="제조사모델번호"
          :visible='true'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="구입년도"
          data-field="구입년도"
          dataType= 'date'
          format='yyyy-MM-dd'
          :visible='true'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="구입가격"
          data-field="구입가격"
          :visible='true'
          format='#,##0'
          dataType="number"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="비고"
          data-field="비고"
          :visible='true'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="사용유무"
          data-field="사용유무"
          :visible='true'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="삭제유무"
          data-field="삭제유무"
          :visible='true'
        >
        </DxColumn>
        <DxSummary>
          <DxTotalItem
            value-format='#,##0'
            show-in-column="라인코드"
            display-format="{0} (건)"
          />
        </DxSummary>
        <dx-paging :enabled="false"/>
        <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <dx-sorting mode="multiple"/>
      </dx-data-grid>
    </div>
    <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
  </div> <!--sub-conten end-->

</template>

<script>
import Loading from 'vue-loading-overlay'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, { DxScrolling, DxFilterRow, DxExport, DxColumnFixing, DxTotalItem, DxForm,
  DxSummary, DxColumn, DxPaging, DxSorting, DxEditing, DxSearchPanel, DxLookup, DxPopup, DxPosition } from 'devextreme-vue/data-grid'
import {
  DxRequiredRule
} from 'devextreme-vue/validator'
import { DxItem } from 'devextreme-vue/form'

export default {
  name: 'product-line',
  data: function () {
    return {
      crudAllow: ConstDef.CRUD_ALLOW_생산_연구,
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      machineInfoList: null,
      focusedRowKey: null,
      machineTypeLookup: null,
      processingTypeLookup: null,
      isIdEdit: true,
      editButtons: ['edit', 'delete']
    }
  },
  components: {
    Loading,
    DxDataGrid,
    DxScrolling,
    DxFilterRow,
    DxExport,
    DxColumnFixing,
    DxTotalItem,
    DxForm,
    DxSummary,
    DxColumn,
    DxPaging,
    DxSorting,
    DxEditing,
    DxSearchPanel,
    DxLookup,
    DxPopup,
    DxPosition,
    DxRequiredRule,
    DxItem
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
    }
    this.machineTypeLookup = this.$_.sortBy(this.$store.getters.getBaseDataByType(ConstDef.설비유형), '설명')
    this.refreshMachineInfo()
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    onEditorPreparing (e) {
      if (e.dataField === '설비코드' && e.row !== undefined) {
        if (e.row.isNewRow === true) {
          this.isIdEdit = true
        } else {
          this.isIdEdit = false
        }
      }
    },
    onInitNewRow (row) {
      row.data.사용유무 = true
      row.data.삭제유무 = false
    },
    onRowInserted (row) {
      row.data.updatetime = row.data.createtime = AppLib.getToday()
      row.data.updateid = row.data.createid = this.userInfo.userName
      if (row.data.구입년도 !== null && (typeof row.data.구입년도) === 'object') {
        row.data.구입년도 = AppLib.formatDateFromTimeStamp(row.data.구입년도.getTime())
      } else if (AppLib.isNumeric(row.data.구입년도)) {
        row.data.구입년도 = AppLib.formatDateFromTimeStamp(row.data.구입년도)
      }
      console.log(row.data.구입년도)
      this.$_sp.runInsertSqlProc('설비정보', null, [row.data])
        .then((data) => {
          this.$snotify.info('추가되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            console.log(error)
          }
        })
    },
    onRowInserting (row) {
      const index = this.$_.findIndex(this.machineInfoList, { 설비코드: row.data.설비코드 })
      if (index >= 0) {
        this.$snotify.info('설비코드가 중복 되었습니다.')
        row.cancel = true
      }
    },
    onRowRemoved (row) {
      this.$_sp.runDeleteSqlProc('설비정보', [{ 설비코드: row.data.설비코드 }])
        .then((data) => {
          this.$snotify.info('삭제되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            console.log(error)
          }
        })
    },
    onRowUpdated (row) {
      row.data.updatetime = AppLib.getNow()
      row.data.updateid = this.userInfo.userName
      if (row.data.구입년도 !== null && (typeof row.data.구입년도) === 'object') {
        row.data.구입년도 = AppLib.formatDateFromTimeStamp(row.data.구입년도.getTime())
      } else if (AppLib.isNumeric(row.data.구입년도)) {
        row.data.구입년도 = AppLib.formatDateFromTimeStamp(row.data.구입년도)
      }
      console.log(row.data.구입년도)
      let array = []
      array.push(AppLib.deleteUnderlineKey(row.data))
      this.$_sp.runUpdateSqlProc('설비정보', ['설비코드'], null, array)
        .then((data) => {
          this.$snotify.info('저장 되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            console.log(error)
          }
        })
    },
    onUpdating (row) {

    },
    onSelectionChanged (e) {

    },
    refreshMachineInfo () {
      this.$_sp.runNoEncodeFindSqlProc('설비정보', null)
        .then((data) => {
          this.machineInfoList = this.$_sp.MakeModel(data)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            console.log(error)
          }
        })
    }
  }
}
</script>

<style lang="scss">
</style>
